import { MenuItemType } from '@common/models/menu-item.type';
import {
  ROUTE_CREATE,
  ROUTE_FORMS,
  ROUTE_INDEX,
  ROUTE_JOBS,
  ROUTE_LIST,
  ROUTE_LOCATIONS,
  ROUTE_MAINTENANCE,
  ROUTE_OPERATIONS,
  ROUTE_PRODUCTS,
  ROUTE_ROLES_PERMISSIONS,
  ROUTE_USERS,
} from './route-paths.config';

export const MENU_ITEMS: MenuItemType[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: 'ri-dashboard-3-line',
    url: `/${ROUTE_INDEX}`,
    // badge: {
    //   variant: 'danger',
    //   text: '5',
    // },
  },
  {
    key: 'maintenance',
    label: 'Mantenimiento',
    isTitle: true,
  },
  {
    key: ROUTE_USERS,
    label: 'Usuarios',
    icon: 'ri-user-line',
    collapsed: true,
    children: [
      {
        key: 'list-users',
        label: 'Lista de Usuarios',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_USERS}/${ROUTE_LIST}`,
        parentKey: ROUTE_USERS,
      },
      {
        key: 'create-user',
        label: 'Crear Usuario',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_USERS}/${ROUTE_CREATE}`,
        parentKey: ROUTE_USERS,
      },
    ],
  },
  {
    key: ROUTE_ROLES_PERMISSIONS,
    label: 'Roles y Permisos',
    icon: 'ri-lock-line',
    collapsed: true,
    children: [
      {
        key: 'roles-permissions',
        label: 'Asignar Roles y Permisos',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_ROLES_PERMISSIONS}/${ROUTE_CREATE}`,
        parentKey: ROUTE_ROLES_PERMISSIONS,
      },
    ],
  },
  {
    key: ROUTE_LOCATIONS,
    label: 'Locales',
    icon: 'ri-building-4-line',
    collapsed: true,
    children: [
      {
        key: 'list-locations',
        label: 'Lista de Locales',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_LOCATIONS}/${ROUTE_LIST}`,
        parentKey: ROUTE_LOCATIONS,
      },

      {
        key: 'create-location',
        label: 'Crear Local',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_LOCATIONS}/${ROUTE_CREATE}`,
        parentKey: ROUTE_LOCATIONS,
      },
    ],
  },
  {
    key: ROUTE_PRODUCTS,
    label: 'Productos',
    icon: 'ri-shopping-bag-line',
    collapsed: true,
    children: [
      {
        key: 'list-products',
        label: 'Lista de Productos',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_PRODUCTS}/${ROUTE_LIST}`,
        parentKey: ROUTE_PRODUCTS,
      },
      {
        key: 'create-product',
        label: 'Crear Producto',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_PRODUCTS}/${ROUTE_CREATE}`,
        parentKey: ROUTE_PRODUCTS,
      },
    ],
  },
  {
    key: ROUTE_FORMS,
    label: 'Formularios',
    icon: 'ri-file-list-3-line',
    collapsed: true,
    children: [
      {
        key: 'list-forms',
        label: 'Lista de Formularios',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_FORMS}/${ROUTE_LIST}`,
        parentKey: ROUTE_FORMS,
      },
      {
        key: 'create-form',
        label: 'Crear Formulario',
        url: `/${ROUTE_MAINTENANCE}/${ROUTE_FORMS}/${ROUTE_CREATE}`,
        parentKey: ROUTE_FORMS,
      },
    ],
  },
  {
    key: 'operations',
    label: 'Operaciones',
    isTitle: true,
  },
  {
    key: ROUTE_JOBS,
    label: 'Trabajos',
    icon: 'ri-tools-line',
    collapsed: true,
    children: [
      {
        key: 'list-jobs',
        label: 'Lista de Trabajos',
        url: `/${ROUTE_OPERATIONS}/${ROUTE_JOBS}/${ROUTE_LIST}`,
        parentKey: ROUTE_JOBS,
      },
      {
        key: 'create-job',
        label: 'Crear Trabajo',
        url: `/${ROUTE_OPERATIONS}/${ROUTE_JOBS}/${ROUTE_CREATE}`,
        parentKey: ROUTE_JOBS,
      },
    ],
  },
];
